import { documentTypesById } from '@constants/documentTypes';
import { TypesDocumentIds } from '@pages/employees/constants/Employees';

/**
 * This gives the document type name.
 * @param {string} id - Document type id
 * @returns {string}
 */
export const getTypeDocumentName = (id: string): string => {
    return id === TypesDocumentIds.NIT ? 'nit' : 'cc';
};

/**
 * Util to get the values of the document and verification.
 * @param {string} id - Document type id
 * @param {string} document - Document number
 * @returns {{document: string; verification: string}}
 */
export const getValuesDocumentNit = (id: string, document: string): { document: string; verification: string } => {
    if (id !== TypesDocumentIds.NIT) {
        return {
            document,
            verification: '',
        };
    }
    const formatDocument = document.slice(0, document.length - 1);
    const verification = document.slice(document.length - 1);

    return {
        document: formatDocument,
        verification,
    };
};

/**
 * This gives the document type id.
 * @param {string} documentTypeId - Document type id
 * @returns {string} - document type prefix CC, NIT, etc.
 */
export const getDocumentTypeId = (documentTypeId: string): string => {
    const documentId = documentTypeId ?? '';
    return documentId in documentTypesById ? documentTypesById[documentId as keyof typeof documentTypesById] : 'CC';
};
